import { c as _c } from "react/compiler-runtime";
export default function CreateWaveInlineGroupDraftSummary(t0) {
  const $ = _c(16);
  const {
    draftSummary,
    isValid,
    canResetDraft,
    canCreateDraft,
    isCreating,
    onStartOver,
    onCreateAndUse
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-50">Ready to create this inline group</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isValid ? draftSummary : "Draft is incomplete. Check the selected rules before creating it.";
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="tw-min-w-0">{t1}<p className="tw-mb-0 tw-mt-1 tw-text-xs tw-text-iron-400">{t2}</p></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !canResetDraft;
  let t5;
  if ($[3] !== onStartOver || $[4] !== t4) {
    t5 = <button type="button" disabled={t4} onClick={onStartOver} className="tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-iron-300 tw-transition tw-duration-200 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-bg-iron-800">Start over</button>;
    $[3] = onStartOver;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = !canCreateDraft;
  const t7 = isCreating ? "Creating..." : "Create + use";
  let t8;
  if ($[6] !== onCreateAndUse || $[7] !== t6 || $[8] !== t7) {
    t8 = <button type="button" disabled={t6} onClick={onCreateAndUse} className="tw-rounded-lg tw-border tw-border-solid tw-border-primary-500 tw-bg-primary-500 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-transition tw-duration-200 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-bg-primary-600">{t7}</button>;
    $[6] = onCreateAndUse;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5 || $[11] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-2">{t5}{t8}</div>;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t3 || $[14] !== t9) {
    t10 = <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900/60 tw-p-3">{t3}{t9}</div>;
    $[13] = t3;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}